import { reg_custom_components } from "./utils/result.js"



//TODO: add an optional control window with close button
//
//
export class McPopUp extends HTMLElement {
  static elname = "mc-popup"
  /** @type {Animation} **/
  animation;

  constructor() {
    super()
    this.attachShadow({ mode: "open" })
    const template = document.createElement("template")
    template.innerHTML = `
<link rel="stylesheet" href="mache.css">
<style>

  :host {
    display: flex;
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    background-color: hsl(var(--mc-surface));
    z-index: 200;
    padding: 1rem;
    box-shadow: 0 0 0 .1rem hsl(var(--mc-surface)/.7), 0 0 1rem .1rem rgba(0,0,0,.1);

    border-radius: 10px;
    border-width: 1px;
    border-color: hsl(var(--mc-text)/.1);
    border-style: solid;

    .nav {
      display: none;
    }
  }

  :host([nav="show"]) {
    padding-top: 1.5rem;
    .nav {
      position: absolute;
      width:95%;
      padding: .2rem 0 0 0;
      top: 0;
      display: flex;
      justify-content: end;

      mc-icon-close-circle {
        cursor: pointer;
      }
  }
</style>
<div class="mc-flex mc-row nav">
  <mc-icon-close-circle id="close_btn"></mc-icon-close-circle>
</div>
<slot></slot>
`
    this.shadowRoot.append(template.content.cloneNode(true))
  }


  connectedCallback() {
    this.animation = this.animate([
      { top: "70%", transform: "translate(-50%, -50%) scale(0)" },
      { top: "60%", transform: "translate(-50%, -50%) scale(.5)" },
      { top: "50%", transform: "translate(-50%, -50%) scale(.6)" },
      { top: "45%", transform: "translate(-50%, -50%) scale(.7)" },
      { top: "46%", transform: "translate(-50%, -50%) scale(.6)" },
      { top: "50%", transform: "translate(-50%, -50%) scale(1)" }
    ], {
      fill: "forwards",
      easing: "ease-in-out",
      duration: 500
    })


    this.close_btn_actions()
  }




  close_btn_actions() {
    let btn = this.shadowRoot.querySelector("#close_btn")
    btn.onclick = () => {
      this.close()
    }
  }


  /**
   * Show the navegation menu for the [McPopUp]
   **/
  display_nav() {
    this.setAttribute("nav", "show")
  }


  /**
   * @param {function(): void} callback
   **/
  close(callback) {
    if (callback) {
      callback()
    }
    this.animation.reverse();
    setTimeout(() => { this.remove() }, 500);
  }

  /**
   * Creates a new pop up
   * @param {HTMLElement} el
   * @return {McPopUp}
   **/
  static new(el) {
    const p = new McPopUp();
    p.append(el)
    return p;
  }

}

reg_custom_components(McPopUp)

/**
 * Creates a new popup
 * @param {HTMLElement} el
 * @returns McPopUp
 **/
export function new_popup(el) {
  return McPopUp.new(el)
}


